import React from "react";

export const HorizontalBarChart = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={28} height={28} rx={1} fill="#F1F2F6" />

    <g
      stroke="#8E97A9"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1={4} y1={4} x2={19} y2={4} />
      <line x1={4} y1={9} x2={15} y2={9} />
      <line x1={4} y1={14} x2={10} y2={14} />
      <line x1={4} y1={19} x2={19} y2={19} />
      <line x1={4} y1={24} x2={16} y2={24} />
    </g>
  </g>
);
